/* Price disclosures only: Skio and Rebuy retain control of cart changes. */
(() => {
  'use strict';
  function offer(variant, planId) {
    const allocation=variant?.selling_plan_allocations?.find(a=>String(a.selling_plan_id)===String(planId));
    if(!allocation || !Number.isSafeInteger(allocation.price) || !Number.isSafeInteger(variant.price)) return null;
    const adjustments=allocation.price_adjustments || [];
    // Only describe a stable, pay-per-delivery offer. Leave other plan types to the app.
    if(allocation.price<0 || allocation.per_delivery_price!==allocation.price || adjustments.some(a=>a.price!==allocation.price)) return null;
    return {price:allocation.price,saving:Math.max(0,variant.price-allocation.price)};
  }
  function sharedOffer(variant) {
    const allocations=variant?.selling_plan_allocations || [];
    const offers=allocations.map(a=>offer(variant,a.selling_plan_id));
    return offers.length && offers.every(o=>o && o.price===offers[0].price) ? offers[0] : null;
  }
  if(typeof module!=='undefined' && module.exports) module.exports={offer,sharedOffer};
  if(typeof document==='undefined') return;
  const configNode=document.getElementById('subscription-clarity-config');
  if(!configNode) return;
  const config=JSON.parse(configNode.textContent), text=config.text;
  const money=value=>new Intl.NumberFormat(config.locale,{style:'currency',currency:config.currency}).format(value/100);
  const phrase=(key,amount)=>text[key].replace('{amount}',money(amount));
  function setText(el,value){if(el.textContent!==value)el.textContent=value;}
  function child(parent,tag,className){let el=parent.querySelector('.'+className);if(!el){el=document.createElement(tag);el.className=className;parent.append(el);}return el;}
  const parsed=new WeakMap();
  function updatePickers(){
    document.querySelectorAll('skio-subscription').forEach(host=>{
      try {
        const json=host.querySelector('[skio-product-json]');
        if(!json)return;
        if(!parsed.has(json))parsed.set(json,JSON.parse(json.textContent));
        const product=parsed.get(json),form=document.getElementById(host.dataset.formId);
        const variant=product.variants.find(v=>String(v.id)===String(form?.querySelector('[name="id"]')?.value));
        if(!variant)return;
        // Skio can initialize after the theme's short startup retry window.
        // Synchronize the sticky price from this product's actual selected radio/plan.
        const sticky=document.querySelector('add-to-cart-sticky');
        const stickySelect=sticky?.querySelector('[data-product-variant-id]');
        const selected=host.querySelector('.skio-group-input:checked');
        if(selected && String(stickySelect?.dataset.productVariantId)===String(variant.id)){
          const planId=selected.closest('[skio-group-container]')?.querySelector('select.skio-frequency')?.value;
          const allocation=variant.selling_plan_allocations?.find(a=>String(a.selling_plan_id)===String(planId));
          const oneTime=selected.hasAttribute('skio-one-time');
          const price=oneTime?variant.price:allocation?.price;
          const compare=oneTime?variant.compare_at_price:allocation?.compare_at_price;
          const priceNode=sticky.querySelector('[data-price]'),compareNode=sticky.querySelector('[data-compare-at-price]');
          if(priceNode && Number.isSafeInteger(price)){
            setText(priceNode,money(price));
            if(compareNode)setText(compareNode,compare>price?money(compare):'');
          }
        }
        host.querySelectorAll('[skio-group-container]').forEach(group=>{
          const select=group.querySelector('select.skio-frequency'),content=group.querySelector('.skio-group-content');
          if(!select||!content)return;
          const current=offer(variant,select.value);
          let summary=content.querySelector('.subscription-clarity-summary');
          if(!current){summary?.remove();return;}
          if(!summary){summary=document.createElement('div');summary.className='subscription-clarity-summary';summary.setAttribute('aria-live','polite');content.prepend(summary);}
          setText(child(summary,'strong','subscription-clarity-price'),phrase('recurring',current.price));
          const saving=child(summary,'span','subscription-clarity-saving');
          saving.hidden=current.saving<=0;setText(saving,phrase('saving',current.saving));
          const note=child(content,'p','subscription-clarity-renewal');setText(note,text.renewal);
          select.setAttribute('aria-label',text.frequency);
          const frequency=child(content,'span','subscription-clarity-frequency');setText(frequency,text.frequency);
          if(frequency.nextElementSibling!==select.parentElement)content.insertBefore(frequency,select.parentElement);
        });
      }catch(_error){/* A missing app render must not interrupt shopping. */}
    });
  }
  const products=new Map();
  function productFor(handle){
    if(!products.has(handle)){
      const root=config.root.replace(/\/?$/,'/');
      products.set(handle,fetch(root+'products/'+encodeURIComponent(handle)+'.js').then(r=>{if(!r.ok)throw Error('Product unavailable');return r.json();}).catch(()=>null));
    }
    return products.get(handle);
  }
  let cartGeneration=0;
  async function updateCart(){
    const generation=++cartGeneration,cart=window.Rebuy?.Cart;
    if(typeof cart?.items!=='function')return;
    const items=cart.items();
    if(!Array.isArray(items))return;
    await Promise.all(Array.from(document.querySelectorAll('.rebuy-cart__flyout-item')).map(async row=>{
      const target=row.querySelector('.rebuy-cart__flyout-item-subscription');
      if(!target)return;
      const link=row.querySelector('.rebuy-cart__flyout-item-product-title');
      const handle=link?.getAttribute('href')?.split('/products/')[1]?.split(/[?#/]/)[0];
      const matches=items.filter(item=>(item.handle||item.product?.handle)===handle);
      // Do not guess which variant or duplicate cart line an app render represents.
      const item=matches.length===1?matches[0]:null;
      if(!item||item.selling_plan_allocation||!target.querySelector('button')){target.querySelector('.subscription-clarity-cart')?.remove();return;}
      const product=await productFor(handle);
      if(generation!==cartGeneration||!row.isConnected)return;
      const variant=product?.variants?.find(v=>String(v.id)===String(item.variant_id||item.id));
      const current=sharedOffer(variant);
      // Existing cart discounts can change the true saving; only quote an undiscounted comparison.
      if(!current||current.saving<=0||item.final_price!==variant.price){target.querySelector('.subscription-clarity-cart')?.remove();return;}
      let panel=target.querySelector('.subscription-clarity-cart');
      if(!panel){panel=document.createElement('div');panel.className='subscription-clarity-cart';target.prepend(panel);}
      setText(child(panel,'span','subscription-clarity-cart-heading'),text.cart_title);
      setText(child(panel,'strong','subscription-clarity-cart-price'),phrase('cart_price',current.price));
      setText(child(panel,'span','subscription-clarity-cart-saving'),phrase('saving',current.saving));
      const details=child(panel,'details','subscription-clarity-plans');
      setText(child(details,'summary','subscription-clarity-plans-title'),text.cart_plans);
      const plans=product.selling_plan_groups.flatMap(g=>g.selling_plans).filter(p=>variant.selling_plan_allocations.some(a=>String(a.selling_plan_id)===String(p.id)));
      setText(child(details,'p','subscription-clarity-plan-list'),plans.map(p=>p.name).join(' · '));
      setText(child(panel,'p','subscription-clarity-cart-note'),text.cart_note);
    }));
  }
  let timer;
  function schedule(){clearTimeout(timer);timer=setTimeout(()=>{updatePickers();updateCart().catch(()=>{});},100);}
  new MutationObserver(records=>{
    if(records.some(r=>!r.target.parentElement?.closest('[class^="subscription-clarity-"]') && !r.target.closest?.('[class^="subscription-clarity-"]')))schedule();
  }).observe(document.body,{childList:true,subtree:true});
  document.addEventListener('change',schedule);
  ['rebuy:smartcart.ready','rebuy:cart.change','rebuy:smartcart.show','change::subscription-option','shopify:section:load'].forEach(name=>document.addEventListener(name,schedule));
  schedule();
})();

